import GeneratedSettingsServiceApi from "./generated/GeneratedSettingsServiceApi"

class SettingsServiceApi extends GeneratedSettingsServiceApi {

}

export const settingsServiceApi = new SettingsServiceApi()
